// extracted by mini-css-extract-plugin
module.exports = {"testimonialWrapper":"_1DCm6"};